import { PlusOutlined } from "@ant-design/icons"
import { Button } from "antd"
import React, { type ReactNode, Suspense, lazy, useState } from "react"

import { type TemplateDocumentTypes } from "../../../../DocumentTemplates/constants/template-document-type.tsx"

const LeadViewTemplatesModal = lazy(() => import("./LeadViewTemplatesModal"))

interface LeadViewTemplatesModalTriggerProps {
  leadId: string
  type: TemplateDocumentTypes
  label?: string
  block?: boolean
  /** Replaces the default button (e.g. to embed this as a dropdown row) — the click still opens the same modal. */
  render?: (onClick: () => void) => ReactNode
}

export function LeadViewTemplatesModalTrigger({
  leadId,
  type,
  label = "Create",
  block,
  render
}: LeadViewTemplatesModalTriggerProps) {
  const [open, setOpen] = useState(false)

  const toggleOpen = () => setOpen((prev) => !prev)

  return (
    <>
      {render ? (
        render(toggleOpen)
      ) : (
        <Button
          block={block}
          type={"primary"}
          icon={<PlusOutlined />}
          onClick={toggleOpen}
        >
          {label}
        </Button>
      )}

      {open && (
        <Suspense
        // fallback={
        //   <Skeleton.Node
        //     active
        //     className={"fixed z-10 m-auto inset-0 w-96 h-44"}
        //   />
        // }
        >
          <LeadViewTemplatesModal
            leadId={leadId}
            type={type}
            onClose={toggleOpen}
          />
        </Suspense>
      )}
    </>
  )
}
